import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime, payText } from "@/lib/api";
import { StatusBadge } from "@/components/Status";

export const AdminReferrals = () => {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/referrals").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const pay = async (r) => {
    const ref = window.prompt(`Mark ₹${r.amount} reward to ${r.referrer} as PAID? Payment ref (UPI / bank, optional):`, "");
    if (ref === null) return;
    try { await api.post(`/admin/referrals/${r.reward_id}/pay`, { ref }); toast.success("Reward marked paid. Customer notified."); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!d) return null;
  const pending = d.rewards.filter((r) => r.status !== "Paid").reduce((s, r) => s + r.amount, 0);
  return (
    <div className="max-w-6xl space-y-4">
      <p className="text-sm text-[#4A6358]">Every customer has a referral code on their Profile. When a referred customer's first pickup is completed, the referrer earns 10% of that pickup's amount. Pay it to their saved UPI/bank and mark it paid here.</p>
      <div className="grid grid-cols-3 gap-3">
        {[["Customers who joined by referral", d.referred_customers], ["Rewards created", d.rewards.length], ["Rewards to pay", `₹${pending.toFixed(2)}`]].map(([l, v]) => (
          <div key={l} className="rounded-2xl border border-[#D2E0D8] bg-white p-4"><p className="font-display text-2xl font-extrabold text-[#0D3B2B]">{v}</p><p className="text-xs font-semibold text-[#4A6358]">{l}</p></div>
        ))}
      </div>
      <div className="overflow-x-auto rounded-2xl border border-[#D2E0D8] bg-white">
        <table className="w-full min-w-[900px] text-left text-sm" data-testid="admin-referrals-table">
          <thead className="bg-[#EAEFEA] text-xs uppercase text-[#4A6358]"><tr>{["Referrer", "Pay to", "Referred customer", "First pickup", "Reward", "Status", ""].map((h) => <th key={h} className="px-3 py-3">{h}</th>)}</tr></thead>
          <tbody>
            {d.rewards.map((r) => (
              <tr key={r.reward_id} className="border-t border-[#EAEFEA]" data-testid={`referral-reward-${r.reward_id}`}>
                <td className="px-3 py-3 font-semibold">{r.referrer}<div className="text-xs font-normal">{r.referrer_mobile}</div></td>
                <td className="px-3 py-3 text-xs">{payText(r.referrer_payment)}</td>
                <td className="px-3 py-3">{r.referee}</td>
                <td className="px-3 py-3">{r.booking_id}<div className="text-xs">₹{r.pickup_amount} · {fmtDateTime(r.created_at)}</div></td>
                <td className="px-3 py-3 font-bold">₹{r.amount}</td>
                <td className="px-3 py-3"><StatusBadge status={r.status} />{r.ref && <div className="text-xs">Ref {r.ref}</div>}</td>
                <td className="px-3 py-3">{r.status !== "Paid" && <button onClick={() => pay(r)} className="rounded-lg bg-[#2E9E6B] px-3 py-1 text-xs font-bold text-white" data-testid={`referral-pay-${r.reward_id}`}>Mark paid</button>}</td>
              </tr>
            ))}
            {!d.rewards.length && <tr><td colSpan={7} className="p-6 text-center text-[#7B968B]">No referral rewards yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
